import { useEffect, useRef } from 'react';

interface BlogAdSenseProps {
  tipo: 'in-article' | 'sidebar' | 'bottom';
  className?: string;
}

// Componente placeholder para anúncios do AdSense
// Substitua o código de slot pelo seu ID real do AdSense
export function BlogAdSense({ tipo, className = '' }: BlogAdSenseProps) {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Inicializar anúncios AdSense quando o componente montar
    // @ts-ignore
    if (window.adsbygoogle && adRef.current) {
      try {
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error('Erro ao carregar anúncio AdSense:', error);
      }
    }
  }, []);

  const getAdConfig = () => {
    switch (tipo) {
      case 'in-article':
        return {
          style: { display: 'block', textAlign: 'center' as const },
          slot: 'SEU_SLOT_IN_ARTICLE_AQUI', // Substitua pelo seu slot
          format: 'fluid',
          layout: 'in-article',
        };
      case 'sidebar':
        return {
          style: { display: 'inline-block', width: '300px', height: '600px' },
          slot: 'SEU_SLOT_SIDEBAR_AQUI',
          format: '',
          layout: '',
        };
      case 'bottom':
        return {
          style: { display: 'block' },
          slot: 'SEU_SLOT_BOTTOM_AQUI',
          format: 'auto',
          layout: '',
        };
      default:
        return {
          style: { display: 'block' },
          slot: '',
          format: 'auto',
          layout: '',
        };
    }
  };

  const config = getAdConfig();

  // Em desenvolvimento, mostrar placeholder
  const isDev = import.meta.env.DEV;

  if (isDev) {
    return (
      <div
        className={`bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center ${className}`}
        style={
          tipo === 'in-article'
            ? { minHeight: '150px', margin: '2rem 0' }
            : tipo === 'sidebar'
            ? { width: '300px', height: '600px' }
            : { minHeight: '150px', margin: '2rem 0' }
        }
      >
        <span className="text-gray-400 text-sm font-medium">
          AdSense - {tipo}
        </span>
        <span className="text-gray-300 text-xs mt-1">
          (apenas em produção)
        </span>
      </div>
    );
  }

  return (
    <div className={`ad-container ${className}`} ref={adRef}>
      <ins
        className="adsbygoogle"
        style={config.style}
        data-ad-client="ca-pub-SEU_CLIENT_ID_AQUI" // Substitua pelo seu ID
        data-ad-slot={config.slot}
        data-ad-format={config.format}
        data-ad-layout={config.layout || undefined}
        data-full-width-responsive="true"
      />
    </div>
  );
}

// AdSense Sidebar para desktop
export function AdSenseSidebar() {
  return (
    <aside className="hidden lg:block lg:w-80 flex-shrink-0">
      <div className="sticky top-24">
        <BlogAdSense tipo="sidebar" className="mx-auto" />
      </div>
    </aside>
  );
}

export default BlogAdSense;
